export default __webpack_public_path__ + "static/media/13.df67fb93.jpg";